import gql from "graphql-tag";
import { Test } from "../baseTypes";
export default gql`
  query SearchTests(
    $filter: SearchableTestFilterInput
    $from: Int
    $limit: Int
    $search: String
  ) {
    searchTests(
      filter: $filter
      from: $from
      limit: $limit
      sort: { field: date }
      search: $search
    ) {
      nextToken
      total
      items {
        companyId
        createdAt
        date
        userId
        locationId
        location {
          name
          id
          locationId
        }
        testId
        result
        identifier
        issuedSelfTests
        patient {
          firstname
          lastname
          insuranceNumber
          email
          birthdate
          addressString
          address {
            street
            number
            city
            zip
            country
          }
        }
        documentation {
          type
          reason
          paymentRequired
          noPaymentRequiredProof
          paymentRecived
        }
        company {
          id
          name
        }
      }
    }
  }
`;
export interface SearchTestsQuery {
  searchTests: {
    items: Array<Test> | null;
    total: number;
  };
}
